/* eslint-disable react-hooks/exhaustive-deps */
import {useCallback} from 'react'
import {RowWithColSpan} from '../components/RowWithColSpan'
import {TableEmptyData} from '../components/TableEmptyData'
import {TableFailedFetchData} from '../components/TableFailedFetchData'
import {TableLoader} from '../components/TableLoader'

interface Args {
  colSpan: number
  onReloadTable: () => void
}

/**
 * Component ini digunakan untuk membuat row table dengan colSpan tertentu
 * dan juga untuk membuat row table dengan kondisi tertentu seperti:
 * - Loading
 * - Error Fetch Data
 * - Empty Data
 *
 * @param colSpan number
 * @param onReloadTable () => void
 */
export const useRowTable = ({colSpan, onReloadTable}: Args) => {
  const RowLoader = () => {
    return <TableLoader colSpan={colSpan} />
  }

  const RowErrorFetch = () => {
    return <TableFailedFetchData colSpan={colSpan} onReloadTable={onReloadTable} />
  }

  const RowEmptyData = () => {
    return <TableEmptyData colSpan={colSpan} onReloadTable={onReloadTable} />
  }

  return {
    RowLoader,
    RowErrorFetch,
    RowEmptyData,
  }
}
